import { render, staticRenderFns } from "./quantidade-selector.vue?vue&type=template&id=54bb6d3e&"
import script from "./quantidade-selector.vue?vue&type=script&lang=js&"
export * from "./quantidade-selector.vue?vue&type=script&lang=js&"
import style0 from "./quantidade-selector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports